(function () {
  function initHoverPersistence(details) {
    if (details.dataset.mmHoverInit) return;
    details.dataset.mmHoverInit = '1';

    var summary = details.querySelector('summary');
    var closeTimer;

    function setExpanded(expanded) {
      details.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function open() {
      window.clearTimeout(closeTimer);
      var others = document.querySelectorAll('.nh-mm-item > details[open]');
      for (var i = 0; i < others.length; i++) {
        if (others[i] !== details) {
          others[i].removeAttribute('open');
          others[i].setAttribute('aria-expanded', 'false');
          var otherSummary = others[i].querySelector('summary');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
        }
      }
      details.setAttribute('open', '');
      setExpanded(true);
    }

    function close() {
      details.removeAttribute('open');
      setExpanded(false);
    }

    function scheduleClose() {
      if (details.dataset.mmDragging) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(close, 150);
    }

    if (summary) {
      summary.addEventListener('click', function (event) {
        var href = summary.dataset.link;
        if (!href) return;
        event.preventDefault();
        window.location.href = href;
      });
    }

    details.addEventListener('mouseover', open);
    details.addEventListener('mouseleave', scheduleClose);
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', function (event) {
      if (event.relatedTarget && !details.contains(event.relatedTarget)) close();
    });

    details.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.keyCode !== 27) return;
      if (!details.open) return;
      close();
      if (summary) summary.focus();
    });
  }

  function initSlider(slider) {
    if (slider.dataset.mmInit) return;
    slider.dataset.mmInit = '1';

    var track = slider.querySelector('[data-mm-slider-track]');
    var bar = slider.querySelector('[data-mm-slider-bar]');
    var fill = slider.querySelector('[data-mm-slider-fill]');
    var arrows = slider.querySelector('[data-mm-slider-arrows]');
    var prevBtn = slider.querySelector('[data-mm-prev]');
    var nextBtn = slider.querySelector('[data-mm-next]');
    if (!track) return;

    var details = slider.closest('details');

    function setDragging(active) {
      if (!details) return;
      if (active) {
        details.dataset.mmDragging = '1';
      } else {
        delete details.dataset.mmDragging;
      }
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function updateFill() {
      var max = maxScroll();
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      if (fill) fill.style.width = Math.max(0, Math.min(1, ratio)) * 100 + '%';
      if (bar) bar.classList.toggle('is-hidden', max <= 1);
      if (arrows) arrows.classList.toggle('is-hidden', max <= 1);
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function scrollByPage(direction) {
      var page = Math.max(track.clientWidth * 0.8, 160);
      if (track.scrollBy) {
        track.scrollBy({ left: direction * page, behavior: 'smooth' });
      } else {
        track.scrollLeft += direction * page;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByPage(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByPage(1);
      });
    }

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;
    var activePointerId = null;

    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    track.addEventListener('pointerdown', function (e) {
      if (typeof e.button === 'number' && e.button !== 0) return;
      isDown = true;
      moved = false;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-grabbing');
      setDragging(true);
    });

    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        if (track.setPointerCapture && activePointerId !== null) {
          try {
            track.setPointerCapture(activePointerId);
          } catch (err) {
            console.error(err);
          }
        }
      }
      track.scrollLeft = startScroll - dx;
      updateFill();
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      activePointerId = null;
      track.classList.remove('is-grabbing');
      setDragging(false);
    }

    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    track.addEventListener('scroll', updateFill, { passive: true });

    if (bar) {
      var barDown = false;

      function scrub(clientX) {
        var rect = bar.getBoundingClientRect();
        if (rect.width <= 0) return;
        var ratio = (clientX - rect.left) / rect.width;
        ratio = Math.max(0, Math.min(1, ratio));
        track.scrollLeft = maxScroll() * ratio;
        updateFill();
      }

      bar.addEventListener('pointerdown', function (e) {
        barDown = true;
        setDragging(true);
        scrub(e.clientX);
        e.preventDefault();
      });
      window.addEventListener('pointermove', function (e) {
        if (barDown) scrub(e.clientX);
      });
      window.addEventListener('pointerup', function () {
        if (!barDown) return;
        barDown = false;
        setDragging(false);
      });
    }

    if (details) {
      details.addEventListener('toggle', function () {
        if (details.open) requestAnimationFrame(updateFill);
      });
    }

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        updateFill();
      });
      ro.observe(track);
    }

    window.addEventListener('resize', updateFill);
    updateFill();
  }

  function initAll() {
    var details = document.querySelectorAll('.nh-mm-item > details');
    for (var d = 0; d < details.length; d++) initHoverPersistence(details[d]);

    var sliders = document.querySelectorAll('[data-mm-slider]');
    for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
